import { Description } from '@headlessui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  closeDeleteTimetableModalAction,
  selectDeleteTimetableModal,
  useAppDispatch,
  useAppSelector,
} from '../../../redux';
import { ConfirmModal } from '../../common/Modals';
import { AffectedRouteLabels } from '../Common/AffectedRouteLabels';
import { useVehicleScheduleFrameValidity } from '../Common/useVehicleScheduleFrameValidity';
import { useDeleteVehicleScheduleFrame } from './Utils';

type DeleteTimetableModalProps = {
  readonly fetchTimetableVersions: () => void;
};

const testIds = {
  closeButton: 'DeleteTimetableModal::closeButton',
  confirmButton: 'DeleteTimetableModal::confirmButton',
  description: 'DeleteTimetableModal::description',
};

export const DeleteTimetableModal: FC<DeleteTimetableModalProps> = ({
  fetchTimetableVersions,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { isOpen, vehicleScheduleFrameId } = useAppSelector(
    selectDeleteTimetableModal,
  );

  const { affectedRouteLabels } = useVehicleScheduleFrameValidity(
    vehicleScheduleFrameId,
  );

  const { deleteVehicleScheduleFrameMutation } = useDeleteVehicleScheduleFrame({
    onCompleted: fetchTimetableVersions,
  });

  const onClose = () => {
    dispatch(closeDeleteTimetableModalAction());
  };

  const onConfirm = async (id: string) => {
    await deleteVehicleScheduleFrameMutation({
      vehicle_schedule_frame_id: id,
    });

    dispatch(closeDeleteTimetableModalAction());
  };

  return (
    <ConfirmModal
      heading={t(($) => $.deleteTimetableModal.title)}
      isOpen={isOpen}
      onCancel={onClose}
      onConfirm={() =>
        vehicleScheduleFrameId && onConfirm(vehicleScheduleFrameId)
      }
      confirmButtonText={t(($) => $.deleteTimetableModal.confirmText)}
      cancelButtonText={t(($) => $.deleteTimetableModal.cancelText)}
    >
      <Description data-testid={testIds.description}>
        {t(($) => $.deleteTimetableModal.description)}
      </Description>
      <AffectedRouteLabels
        affectedRouteLabels={affectedRouteLabels}
        text={t(($) => $.deleteTimetableModal.affectedRoutesText)}
      />
    </ConfirmModal>
  );
};
